import { useEffect } from 'react'
import { useSetAtom } from 'jotai'
import { loadMapAtom } from '@/js/editor/state/mapSessionAtoms.ts'
import { useApi } from '@/js/editor/hooks/api/useApi.ts'

export const useLoadMapSession = (map: string | number) => {
    const loadMap = useSetAtom(loadMapAtom)
    const { callEndpoint } = useApi()

    useEffect(() => {
        const mapId = Number(map) > 0 ? map : null

        if (mapId === null) {
            return
        }

        void loadMap({
            mapId,
            request: (requestedMapId) => callEndpoint(`/api/maps/${requestedMapId}`),
        })
    }, [callEndpoint, loadMap, map])
}
